module.exports = __webpack_public_path__ + "img/Pic_XXFW_ZC.fd92df7b.png";